import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ONLINESTATUS} from '../../../../utils/questionManageType'

import axios from 'axios'
import API  from '../../../../API/api';
import { Button, Input,  Row, Col, message,Modal,Popconfirm,Tooltip} from 'antd';
import {PropTypes} from 'prop-types';
import $ from '$'
import * as action from '../action'
const ButtonGroup = Button.Group;
class DailyError extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        hiddenEdition:true,
    }

    componentDidMount(){
        this.getEditionList()
    }

    getEditionList=()=>{
        this.props.getEditionList({},()=>{
        	
        		if(this.props.handleEdition){
        			this.props.setPropsEditionCurrent(this.props.handleEdition)
        			this.props.setHandleEdition('')
        			return
        		}
        		
            if(!this.props.editionList.some((d)=>{return d.edition_id===this.props.editionCurrent})&&this.props.editionList[0]){
                this.props.setPropsEditionCurrent(this.props.editionList[0].edition_id)
            }
        })
        
    }

    changeEdition=(edition)=>{//更换版本
        this.props.setPropsEditionCurrent(edition.edition_id)
    }
    openEditEdition = (val)=>{//打开本本修改
        this.setState({visibleEdition:true,editEdition:val,name:val.name,mark:val.mark,})
    }
    addEditEdition = ()=>{//版本修改
        this.setState({visibleEdition:true,editEdition:{},name:'',mark:'',})
    }
    editEdition = ()=>{//版本修改
        if(this.state.name===''){
            return message.error('请填写名称')
        }
        let data ={
            name:this.state.name,
            mark:this.state.mark,
        }
        if(this.state.editEdition.edition_id){//编辑的情况
            data.edition_id = this.state.editEdition.edition_id
            axios.post(API.FRAMEEWORK_EDITION_EDIT, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success(res.message)
                    this.props.editionList.forEach(d=>{
                        if(d.edition_id===this.state.editEdition.edition_id){
                            d.name = this.state.name
                            d.mark = this.state.mark
                        }
                    })//成功后直接直接给版本赋值
                    this.props.setPropsEditionList(this.props.editionList)
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})

        }else{                               //添加的情况
            axios.post(API.FRAMEEWORK_EDITION_ADD, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success(res.message)
                    this.getEditionList()
                    this.setState({visibleEdition:false})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }

    delEdition = (id)=>{//删除版本
        let data ={
            edition_id:id,
        }
        axios.post(API.FRAMEEWORK_EDITION_DEL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getEditionList()
                this.props.setPropsEditionCurrent((this.props.editionList[0]&&this.props.editionList[0].edition_id)||'-1')
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onlineEdition= (id)=>{//版本上线
        let data ={
            edition_id:id,
        }
        axios.post(API.FRAMEEWORK_EDITION_ONLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getEditionList()

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    offlineEdition= (id)=>{//版本下线
        let data ={
            edition_id:id,
        }
        axios.post(API.FRAMEEWORK_EDITION_OFFLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getEditionList()

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }


    render() {

        return (
            <div>

                    <Row style={{marginBottom: 20}}>
                            <Col span={2} className="popup-input-title" style={{lineHeight:'28px',textAlign:'center',paddingRight:'5px',fontSize:'15px',fontWeight:'500'}}><label>教材：</label></Col>
                            <Col span={22} style={{paddingLeft:10,textAlign:'left'}}>
                                {
                                    this.props.editionList&&this.props.editionList.map((val, key) =>

                                            <ButtonGroup key={val.edition_id} style={(this.state.hiddenEdition&&!val.count)?{display:'none'}:{marginRight:20,marginBottom:10}}
                                                         size={'small'}
                                                         className={(this.props.editionCurrent!==val.edition_id)&&!val.count?'editionNoCount':''}>
                                                <Tooltip title={val.edition_id} key={val.edition_id}>
                                                    <Button type={this.props.editionCurrent===val.edition_id?'primary':''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                        onClick={()=>{this.changeEdition(val)}}
                                                        value={val.edition_id} >{val.name}--{ONLINESTATUS[val.online_status]}</Button>
                                                </Tooltip>

                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.editEdition&&
                                                    <Tooltip title={'编辑教材'} mouseEnterDelay={1}>
                                                        <Button  type={this.props.editionCurrent===val.edition_id?'primary':''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                onClick={()=>{this.openEditEdition(val)}}
                                                                icon="edit" />
                                                    </Tooltip>

                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.delEdition&&
                                                    <Popconfirm title="确认删除吗？" onConfirm={(e) => {this.delEdition(val.edition_id)}} okText="确认" cancelText="取消">

                                                        <Tooltip title={'删除教材'} mouseEnterDelay={1}>
                                                            <Button  type={this.props.editionCurrent===val.edition_id?'primary':''} icon="delete"  style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}/>
                                                        </Tooltip>
                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.online&&
                                                    <Popconfirm title="确认上线吗？" onConfirm={(e) => {this.onlineEdition(val.edition_id)}} okText="确认" cancelText="取消">

                                                        <Tooltip title={'上线教材'} mouseEnterDelay={1}>
                                                            <Button  type={this.props.editionCurrent===val.edition_id?'primary':''} icon="to-top"  style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}/>
                                                        </Tooltip>
                                                    </Popconfirm>
                                                }
                                                {
                                                    this.props.user.role_assist&&this.props.user.role_assist.offline&&
                                                    <Popconfirm title="确认下线吗？" onConfirm={(e) => {this.offlineEdition(val.edition_id)}} okText="确认" cancelText="取消">
                                                        <Tooltip title={'下线教材'} mouseEnterDelay={1}>
                                                            <Button  type={this.props.editionCurrent===val.edition_id?'primary':''} icon="arrow-down"  style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}/>
                                                        </Tooltip>

                                                    </Popconfirm>
                                                }

                                            </ButtonGroup>
                                    )
                                }
                                <ButtonGroup style={{marginRight:20,marginBottom:10,fontWeight:'600'}}  size={'small'}>
                                    <Button type={'danger'} onClick={()=>{this.setState({hiddenEdition:!this.state.hiddenEdition})}}>
                                        {this.state.hiddenEdition?'显示所有':'隐藏空版本'}
                                    </Button>
                                </ButtonGroup>

                                {
                                    this.props.user.role_assist&&this.props.user.role_assist.addEdition&&
                                    <ButtonGroup style={{marginRight:20,marginBottom:10,fontWeight:'600'}}  size={'small'}>
                                        <Tooltip title={'添加教材'} mouseEnterDelay={1}>
                                            <Button  type={'primary'}
                                                    onClick={()=>{this.addEditEdition()}}
                                                    icon="plus" />
                                        </Tooltip>

                                    </ButtonGroup>
                                }
                            </Col>
                        </Row>
                {/*教材 修改 增加的模态框*/}
                <Modal
                    title={'教材管理'}
                    visible={ this.state.visibleEdition }
                    onOk={ this.editEdition }
                    onCancel={ ()=>{this.setState({visibleEdition:false})} }
                    okText = { '确定' }
                >
                    <Row className="row" >
                        <Col span={2}>名称：</Col>
                        <Col span={22}>
                            <Input placeholder = "输入名称(必填)" value={this.state.name} onChange = { e => this.setState({name:e.target.value}) } />
                        </Col>
                    </Row>
                    <Row className="row"  style={{marginTop:20}}>
                        <Col span={2}>概要</Col>
                        <Col span={22}>
                            <Input placeholder = "输入概要(非必填)" value={this.state.mark} onChange = {  e => this.setState({mark:e.target.value}) } />
                        </Col>
                    </Row>
                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    const asstst = state.knowledgeAssist.assist;
    return {
        user:state.user,
        editionCurrent:asstst.editionCurrent,
        editionList:asstst.editionList,
        handleEdition:asstst.handleEdition,
    };
}

function mapDispatch(dispatch) {
    return{
        setPropsEditionCurrent:(val)=>{
            dispatch(action.setPropsEditionCurrent(val))
        },
        getEditionList:(val,cb)=>{
            dispatch(action.getEditionList(val,cb))
        },
        setPropsEditionList:(val)=>{
            dispatch(action.setPropsEditionList(val))
        },
        setHandleEdition:(val)=>{
            dispatch(action.setHandleEdition(val))
        },
    }
}
export default connect(mapState, mapDispatch)(DailyError);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/Editions/view.js